import dayjs from 'dayjs';
import { FC } from 'react';
import { HeaderProps } from 'react-big-calendar';

import dateService from '@gem/services/date-service';
import { isRussianLocale } from '@gem/utils';

import { capitalizeFirstLetter } from 'APP/utils/calendar/capitalizeFirstLetter';
import { getLanguage } from 'APP/utils/getLanguage';

export const WeekHeader: FC<HeaderProps> = ({ date }) => {
  const dayNameShort = dateService.format(date, { weekday: 'short' });

  return (
    <div className="week-header">
      <div className="week-name-header">
        {isRussianLocale(getLanguage())
          ? capitalizeFirstLetter(dayNameShort, getLanguage())
          : dayNameShort}
      </div>
      <div className="week-day-header">{dayjs(date).format('D')}</div>
    </div>
  );
};
